import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgNone = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><circle cx={8} cy={8} r={8} fill="currentColor" /></svg>;
const ForwardRef = forwardRef(SvgNone);
export default ForwardRef;